// src/components/admin/RegisterAccount.jsx
import React, { useState } from "react";

const RegisterAccount = () => {
  const [account, setAccount] = useState({ username: "", password: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Account for ${account.username} registered!`);
    setAccount({ username: "", password: "" });
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Register Account</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          placeholder="Username"
          className="w-full border px-4 py-2 rounded"
          value={account.username}
          onChange={(e) => setAccount({ ...account, username: e.target.value })}
          required
        />
        <input
          type="password"
          placeholder="Password"
          className="w-full border px-4 py-2 rounded"
          value={account.password}
          onChange={(e) => setAccount({ ...account, password: e.target.value })}
          required
        />
        <button className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
          Register Account
        </button>
      </form>
    </div>
  );
};

export default RegisterAccount;
